import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Row, Col } from 'react-flexbox-grid';
import { Checkbox, Form, Input, Switch } from 'antd';
import { t } from '../../../../app/i18n';

const FormItem = Form.Item;

@translate()
export default class InsuranceForm extends Component {
    static propTypes = {
        form: PropTypes.object.isRequired,
        t: PropTypes.func.isRequired,
        payment: PropTypes.number.isRequired,
        insuranceAmount: PropTypes.number.isRequired,
        insuranceInfo: PropTypes.object,
        onBlurSaveLoanData: PropTypes.func.isRequired,
        showEmployer: PropTypes.bool,
        insuranceValue: PropTypes.string,
        handleInsuranceValueChange: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props)
    
        let showFinaBenefitor = false
        if (props.insuranceInfo && props.insuranceInfo.isFinalBenefitor === false) {
            showFinaBenefitor = true
        }
    
        this.state = {
            showModal: false,
            showFinaBenefitor: showFinaBenefitor,
        };
    }

    handleBenefitorChange = value => {
        this.setState({
          showFinaBenefitor: !value,
        });
    };

    checkFinalBenefitor = (form) => (rule, value, callback) => {
        if (!value && !form.getFieldValue('isFinalBenefitor')) {
            callback(t('Musíte vyplniť konečného užívateľa výhod'))
        } else {
            callback();
        }
      };

    render () {
        const { form, t, payment, insuranceAmount, showEmployer, insuranceValue } = this.props;
        const { getFieldDecorator } = form;

        return (
            <div>
                <Row style={{marginTop: 20}}>
                    <Col xs>
                        <h2 className="section-title">{t('Poistenie splácania pôžičky')}</h2>
                        <p>
                        {t('Zvoľte si k Vašej pôžičke kvalitné poistenie a nemusíte sa báť prípadného výpadku príjmov zapríčineného práceneschopnosťou, úrazom, hospitalizáciou alebo aj stratou zamestnania. Vyberte si poistný balík a poistite si schopnosť splácať Vašu pôžičku.')}
                        </p>
                        <br/>
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <FormItem>
                        {
                            getFieldDecorator('insuranceA', {
                                initialValue: insuranceValue === 'A',
                                valuePropName: 'checked',
                            })(
                            <Checkbox 
                                name={'insuranceA'}
                                //checked={insuranceValue === 'A'}
                                onChange={ e => this.props.handleInsuranceValueChange('A')}
                            >
                                <strong>{t('Balík A')}</strong>
                            </Checkbox>
                            )
                        }
                        </FormItem>
                    </Col>
                    <Col md={10}>
                        <span 
                            className="modal-text"
                            onClick={ () => this.props.handleInsuranceValueChange('A')}
                        >
                            {t("poistenie pre prípad straty života, pripoistenie pre prípad úplnej dočasnej invalidity, pripoistenie pre prípad hospitalizácie následkom úrazu s nákladmi spojenými s poistením")}
                        </span>
                    </Col>
                </Row>

                {
                    showEmployer ?
                    <Row>
                        <Col md={2}>
                        <FormItem>
                            {
                            getFieldDecorator('insuranceB', {
                                initialValue: insuranceValue === 'B',
                                valuePropName: 'checked'
                            })(
                                <Checkbox 
                                name={'insuranceB'}
                                //checked={insuranceValue === 'B'}
                                onChange={ e => this.props.handleInsuranceValueChange('B')}
                                >
                                <strong>{t('Balík B')}</strong>
                                </Checkbox>
                            )
                            }
                        </FormItem>
                        </Col>
                        <Col md={10}>
                        <span 
                            className="modal-text"
                            onClick={ () => this.props.handleInsuranceValueChange('B')}
                        >
                            {t("poistenie pre prípad straty života, pripoistenie pre prípad úplnej trvalej invalidity, pripoistenie pre prípad úplnej dočasnej invalidity, pripoistenie pre prípad nedobrovoľnej straty zamestnania poisteného, pripoistenie pre prípad hospitalizácie následkom úrazu s nákladmi spojenými s Poistením")}
                        </span>
                        </Col>
                    </Row>
                    : 
                    null
                }

                <Row>
                    <Col md={2}>
                        <FormItem>
                        {
                        getFieldDecorator('insuranceC', {
                            initialValue: insuranceValue === 'C',
                            valuePropName: 'checked'
                        })(
                            <Checkbox 
                            name={'insuranceC'}
                            //checked={insuranceValue === 'C'}
                            onChange={ e => this.props.handleInsuranceValueChange('C')}
                            >
                            <strong>{t('Balík C')}</strong>
                            </Checkbox>
                        )
                        }
                        </FormItem>
                    </Col>
                    <Col md={10}>
                        <span 
                        className="modal-text"
                        onClick={ () => this.props.handleInsuranceValueChange('C')}
                        >
                        {t("poistenie pre prípad smrti následkom úrazu s nákladmi spojenými s poistením")}
                        </span>
                    </Col>
                </Row>

                {
                    insuranceValue && 
                    <div>
                        <p>
                            {t(`Mesačná cena poistenia: ${(Number(insuranceAmount)).toFixed(2)} EUR.`)}
                        </p>
                        <p>
                            {t(`Upravená výška splátky vrátane poistenia:  ${(Number(payment)).toFixed(2)} EUR.`)}
                        </p>
                    </div>
                }

                {
                    insuranceValue && 
                    <Row style={{marginTop: 20}}>
                        <Col xs>
                            <h2 className="section-title">{t('Poistenie splácania - doplňujúce informácie')}</h2>
                            <p>
                            {t('Overte a potvrďte prosím uvedené informácie, potrebné pre poistenie Vašej pôžičky.')}
                            </p>
                            <br/>

                            <Row>
                            <Col md={10}>
                                <span>{t("Ste mladší ako ") + (insuranceValue === 'C' ? '70' : '62') + t(" rokov ? ")}</span>
                            </Col>
                            <Col md={2}>
                                <FormItem>
                                {
                                getFieldDecorator('youngerThanLimit', {
                                    initialValue: this.props.insuranceInfo ? this.props.insuranceInfo.youngerThanLimit : true,
                                    valuePropName: 'checked'
                                })(
                                    <Switch 
                                        name={'youngerThanLimit'}
                                        size={'default'}
                                        checkedChildren={t('áno')}
                                        unCheckedChildren={t('nie')}
                                        onBlur={this.props.onBlurSaveLoanData} 
                                    />
                                )
                                }
                                </FormItem>
                            </Col>
                            </Row> 

                            <Row>
                            <Col md={10}>
                                <span>{t("Bol Vám priznaný a poberáte starobný dôchodok?")}</span>
                            </Col>
                            <Col md={2}>
                                <FormItem>
                                {
                                    getFieldDecorator('pension', {
                                    initialValue: this.props.insuranceInfo ? this.props.insuranceInfo.pension : false,
                                    valuePropName: 'checked'
                                    })(
                                    <Switch 
                                        name={'pension'}
                                        size={'default'}
                                        checkedChildren={t('áno')}
                                        unCheckedChildren={t('nie')}
                                        onBlur={this.props.onBlurSaveLoanData}
                                    />
                                    )
                                }
                                </FormItem>
                            </Col>
                            </Row>
                                
                            <Row>
                            <Col md={10}>
                                <span>{t("Bol Vám priznaný a poberáte invalidný dôchodok? ")}</span>
                            </Col>
                            <Col md={2}>
                                <FormItem>
                                {
                                    getFieldDecorator('invalidity', {
                                    initialValue: this.props.insuranceInfo ? this.props.insuranceInfo.invalidity : false,
                                    valuePropName: 'checked'
                                    })(
                                    <Switch 
                                        name={'invalidity'}
                                        size={'default'}
                                        checkedChildren={t('áno')}
                                        unCheckedChildren={t('nie')}
                                        onBlur={this.props.onBlurSaveLoanData}
                                    />
                                    )
                                }
                                </FormItem>
                            </Col>
                            </Row>

                            <Row>
                            <Col md={10}>
                                <span>{t("Ste v pracovnej neschopnosti? ")}</span>
                            </Col>
                            <Col md={2}>
                                <FormItem>
                                {
                                    getFieldDecorator('unableToWork', {
                                    initialValue: this.props.insuranceInfo ? this.props.insuranceInfo.unableToWork : false,
                                    valuePropName: 'checked'
                                    })(
                                    <Switch 
                                        name={'unableToWork'}
                                        size={'default'}
                                        checkedChildren={t('áno')}
                                        unCheckedChildren={t('nie')}
                                        onBlur={this.props.onBlurSaveLoanData}
                                    />
                                    )
                                }
                                </FormItem>
                            </Col>
                            </Row>

                            <Row style={{marginBottom: 20}}>
                            <Col md={10}>
                                <span>{t("Ste osobou v osobitnom vzťahu k Poisťovni v zmysle zákona č. 39/2015 Z. z o poisťovníctve a o doplnení niektorých zákonov ?")}</span>
                            </Col>
                            <Col md={2}>
                                <FormItem>
                                {
                                    getFieldDecorator('inRelationshipWithInsCompany', {
                                    initialValue: this.props.insuranceInfo ? this.props.insuranceInfo.inRelationshipWithInsCompany : false,
                                    valuePropName: 'checked'
                                    })(
                                    <Switch
                                        name={'inRelationshipWithInsCompany'}
                                        size={'default'}
                                        checkedChildren={t('áno')}
                                        unCheckedChildren={t('nie')}
                                        onBlur={this.props.onBlurSaveLoanData}
                                    />
                                    )
                                }
                                </FormItem>
                            </Col>
                            </Row>

                            <Row style={{marginBottom: 20}}>
                            <Col md={10}>
                                <span>{t("Ste politicky exponovanou osobou v zmysle zákona č. 297/2008 Z. z. o ochrane pred legalizáciou príjmov z trestnej činnosti a o ochrane pred financovaním terorizmu a o zmene a doplnení niektorých zákonov v znení neskorších predpisov ?")}</span>
                            </Col>
                            <Col md={2}>
                                <FormItem>
                                {
                                    getFieldDecorator('isPoliticalPerson', {
                                    initialValue: this.props.insuranceInfo ? this.props.insuranceInfo.isPoliticalPerson : false,
                                    valuePropName: 'checked'
                                    })(
                                    <Switch 
                                        name={'isPoliticalPerson'}
                                        size={'default'}
                                        checkedChildren={t('áno')}
                                        unCheckedChildren={t('nie')}
                                        onBlur={this.props.onBlurSaveLoanData} 
                                    />
                                    )
                                }
                                </FormItem>
                            </Col>
                            </Row>

                            <Row style={{marginBottom: 20}}>
                            <Col md={10}>
                                <span>{t("Ste sankcionovanou osobou v zmysle zákona č. 289/2016 Z. z. o vykonávaní medzinárodných sankcií a o doplnení zákona č. 566/2001 Z. z. o cenných papieroch a investičných službách a o zmene a doplnení niektorých zákonov (zákon o cenných papieroch) v znení neskorších predpisov ?")}</span>
                            </Col>
                            <Col md={2}>
                                <FormItem>
                                {
                                    getFieldDecorator('isSanctioned', {
                                    initialValue: this.props.insuranceInfo ? this.props.insuranceInfo.isSanctioned : false,
                                    valuePropName: 'checked'
                                    })(
                                    <Switch 
                                        name={'isSanctioned'}
                                        size={'default'}
                                        checkedChildren={t('áno')}
                                        unCheckedChildren={t('nie')}
                                        onBlur={this.props.onBlurSaveLoanData} 
                                    />
                                    )
                                }
                                </FormItem>
                            </Col>
                            </Row>

                            <Row style={{marginBottom: 10}}>
                            <Col md={10}>
                                <span>{t("Ste konečným užívateľom výhod v zmysle § 6a zákona č. 297/2008 Z. z.; v prípade, ak klient nie je konečným užívateľom výhod, konečným užívateľom výhod je (meno a priezvisko, bydlisko, rodné číslo, dátum narodenia, číslo dokladu totožnosti):")}</span>
                            </Col>
                            <Col md={2}>
                                <FormItem>
                                {
                                    getFieldDecorator('isFinalBenefitor', {
                                    initialValue: (this.props.insuranceInfo && this.props.insuranceInfo.isFinalBenefitor !== undefined) ? this.props.insuranceInfo.isFinalBenefitor : true,
                                    valuePropName: 'checked'
                                    })(
                                    <Switch 
                                        name={'isFinalBenefitor'}
                                        size={'default'}
                                        checkedChildren={t('áno')}
                                        unCheckedChildren={t('nie')}
                                        onBlur={this.props.onBlurSaveLoanData}
                                        onChange={this.handleBenefitorChange}
                                    />
                                    )
                                }
                                </FormItem>
                            </Col>
                            </Row>

                            { this.state.showFinaBenefitor ?
                            <Row style={{marginBottom: 20}}>
                                <Col xs>
                                <span>{t("Konečným užívateľom výhod je:")}</span>
                                <FormItem>
                                    { 
                                        getFieldDecorator('finalBenefitor', {
                                        initialValue: this.props.insuranceInfo ? this.props.insuranceInfo.finalBenefitor : null,
                                        rules: [{
                                            validator: this.checkFinalBenefitor(form),
                                        }],
                                    }) (
                                        <Input
                                            name='finalBenefitor'
                                            size='default'
                                            type='textarea'
                                            placeholder={t('Konečný užívateľ výhod')}
                                            onBlur={this.props.onBlurSaveLoanData} 
                                        />
                                        )
                                    }
                                </FormItem>
                                </Col>
                            </Row> : null
                            }

                            <Row>
                            <Col xs>
                                <FormItem label={t('Doplňujúce informácie')}>
                                {getFieldDecorator('insuranceNotes', {
                                    initialValue: this.props.insuranceInfo ? this.props.insuranceInfo.notes : null
                                })(
                                    <Input
                                        name='insuranceNotes'
                                        size='default'
                                        type='textarea'
                                        placeholder={t('Doplňujúce informácie ku poisteniu')} 
                                        onBlur={this.props.onBlurSaveLoanData} 
                                    />
                                )
                                }
                                </FormItem>
                            </Col>
                            </Row>

                        </Col>
                    </Row>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/features/onboarding/components/debtor/insuranceForm.js